var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app-bar',{attrs:{"app":"","dense":"","color":"primary","dark":""}},[_c('div',{staticClass:"d-flex align-center"}),_c('h2',[_vm._v("Cetak Struk")]),_c('v-spacer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }